export default {
  DASHBOARD_SET_STATE: '@dashboard/DASHBOARD_SET_STATE',
  DASHBOARD_DATA_REQUEST: '@dashboard/DASHBOARD_SETUP_SAVE',
};
